module.exports = __webpack_public_path__ + "img/joystick.a828d676.svg";